.timed-ghost-result {
    --square-progress-color: var(--color-primary);
    --square-progress-width: 18;
    display: inline-block;
    width: 1em;
    height: 1em;
    margin: 0 0.25em;
    opacity: 0.5;
}
